// Vendor libraries
import { ChangeDetectorRef } from '@angular/core';
// Services
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
// Directives
import { AutocompleteInPlaceDirective } from './autocomplete-in-place.directive';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "WatchlistApp/ts/services/watchlists.service";
import * as i3 from "../base-autocomplete/components/base-autocomplete.component";
import * as i4 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = a0 => ({ "is-editing": a0 });
const _c1 = a0 => ({ "field-input-group relative": a0 });
const _c2 = a0 => ({ "form-control field-input min-height-base": a0 });
const _c3 = a0 => ({ "pointer-events": a0 });
function SecurityAutocompleteInPlaceComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.errorMessage, i0.ɵɵsanitizeHtml);
} }
function SecurityAutocompleteInPlaceComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function SecurityAutocompleteInPlaceComponent_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.edit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(5, _c3, ctx_r1.disableEditBtn || ctx_r1.blockInput ? "none" : "auto"));
    i0.ɵɵproperty("disabled", ctx_r1.disableEditBtn)("tooltipTitle", ctx_r1.tooltipText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-edit");
} }
function SecurityAutocompleteInPlaceComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵlistener("click", function SecurityAutocompleteInPlaceComponent_div_6_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.remove()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", ctx_r1.tooltipText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function SecurityAutocompleteInPlaceComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16)(1, "a", 17);
    i0.ɵɵlistener("click", function SecurityAutocompleteInPlaceComponent_span_10_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancel()); });
    i0.ɵɵtext(2, " Cancel ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.displayValue);
} }
/**
 *
 * Security Autocomplete In Place Component
 *
 * Most of the logic is handled by the abstract base class `AutocompleteInPlaceDirective`, please see for
 * further documentation.
 *
 * Input Properties:
 *   blockInput: Whether the input field is disabled.
 *   displayIdentifier: The watchlist id/security symbol used to fetch the name from the backend.
 *   includeSearchIcon: Whether the magnifying glass search icon is included in the autocomplete search bar.
 *
 */
export class SecurityAutocompleteInPlaceComponent extends AutocompleteInPlaceDirective {
    constructor(changeDetector, securitiesService, watchlistService) {
        super(changeDetector);
        this.securitiesService = securitiesService;
        this.watchlistService = watchlistService;
        this.includeSearchIcon = false;
        this.blockInput = false;
    }
    setDisplayValue() {
        /**
         * If a new displayIdentifier was set and is a number, use the `watchlistService` to get the watchlist name.
         * If a new displayIdentifier was set and is a string, use the `securitiesService` to get the security name.
         * If the selected watchlist/security does not exist in the backend, reset the autocompleter.
         */
        // Checks if displayIdentifier is a number, which means it's a watchlist id
        if (+this.displayIdentifier) {
            this.watchlistService.getWatchlistInfo([this.displayIdentifier]).subscribe({
                next: (data) => {
                    this.displayValue = data[0]?.name;
                    this.isEditing = !this.displayValue;
                },
                error: () => {
                    // If no watchlist with this symbol exists, reset the autocompleter
                    this.reset();
                },
            });
        }
        else {
            this.securitiesService.getSecuritiesInfo(this.displayIdentifier).subscribe({
                next: (data) => {
                    this.displayValue = data[0]?.security_name;
                    this.isEditing = !this.displayValue;
                },
                error: () => {
                    // If no security with this symbol exists, reset the autocompleter
                    this.reset();
                },
            });
        }
    }
}
SecurityAutocompleteInPlaceComponent.ɵfac = function SecurityAutocompleteInPlaceComponent_Factory(t) { return new (t || SecurityAutocompleteInPlaceComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.WatchlistsService)); };
SecurityAutocompleteInPlaceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SecurityAutocompleteInPlaceComponent, selectors: [["ycn-security-autocomplete-in-place"]], inputs: { displayIdentifier: "displayIdentifier", includeSearchIcon: "includeSearchIcon", blockInput: "blockInput" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 12, vars: 24, consts: [["autocompleteComponent", ""], [1, "form-group-editable", 3, "ngClass"], [1, "form-value", 3, "ngClass"], [3, "ngClass"], ["class", "text-signal-orange-1", 3, "innerHTML", 4, "ngIf"], ["class", "btn btn-circle btn-transparent btn-edit", "ycnTooltip", "", "ycnDisabled", "", 3, "disabled", "tooltipTitle", "style", "click", 4, "ngIf"], ["class", "field-input-group-actions", 4, "ngIf"], [1, "input-group"], [1, "input-group", "field-input-group", 3, "blurHandler", "submitHandler", "appendToBody", "buttonType", "includeSearchIcon", "isDisabled", "placeholder", "searchType", "searchBlockRegex"], ["class", "input-group-btn", 4, "ngIf"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [1, "text-signal-orange-1", 3, "innerHTML"], ["ycnTooltip", "", "ycnDisabled", "", 1, "btn", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "disabled", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "field-input-group-actions"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "tooltipTitle"], [1, "input-group-btn"], ["href", "javascript:void(0)", 1, "btn", "btn-secondary", 3, "click", "hidden"]], template: function SecurityAutocompleteInPlaceComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3);
        i0.ɵɵtemplate(4, SecurityAutocompleteInPlaceComponent_div_4_Template, 1, 1, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, SecurityAutocompleteInPlaceComponent_div_5_Template, 2, 7, "div", 5)(6, SecurityAutocompleteInPlaceComponent_div_6_Template, 3, 2, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7)(8, "ycn-base-autocomplete", 8, 0);
        i0.ɵɵlistener("blurHandler", function SecurityAutocompleteInPlaceComponent_Template_ycn_base_autocomplete_blurHandler_8_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.blurHandler()); })("submitHandler", function SecurityAutocompleteInPlaceComponent_Template_ycn_base_autocomplete_submitHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, SecurityAutocompleteInPlaceComponent_span_10_Template, 3, 1, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "ycn-confirm-modal", 10);
        i0.ɵɵlistener("confirmHandler", function SecurityAutocompleteInPlaceComponent_Template_ycn_confirm_modal_confirmHandler_11_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmCallback($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0, ctx.isEditing));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c1, ctx.showRemove));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c2, ctx.showRemove));
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.displayValue, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.showRemove);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showRemove);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("appendToBody", ctx.appendToBody)("buttonType", ctx.buttonType)("includeSearchIcon", ctx.includeSearchIcon)("isDisabled", ctx.disableAutocompleterInput)("placeholder", ctx.placeholder)("searchType", ctx.searchType)("searchBlockRegex", ctx.searchBlockRegex);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hideCancelButton);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonText", "Continue")("confirmHeader", "Confirm Selection")("confirmText", ctx.confirmMessage);
    } }, dependencies: [i3.BaseAutocompleteComponent, i4.DisabledDirective, i5.NgClass, i5.NgIf, i6.ConfirmModalComponent, i7.IconDirective, i8.TooltipDirective], encapsulation: 2 });
